/* Range Overview Client barrel export */

import { RangeOverviewClientMocked } from './rangeOverviewClientMocked';

// Re-export types
export * from './rangeOverviewTypes';

// No real backend exists yet - always use the in-code mocked client.
const rangeOverviewClient = new RangeOverviewClientMocked();

export { rangeOverviewClient, RangeOverviewClientMocked };
export type { IRangeOverviewClient } from './IRangeOverviewClient';
